module.exports = __webpack_public_path__ + "static/image-06-a@2x-c0cd541a79c0e98a08c2391b31a1130d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/image-06-a@2x.jpg
// module id = 442
// module chunks = 3627797113349 20562973939449 33019919093843